{
  "auth.login.email.label": "Email",
  "auth.login.email.placeholder": "Email",
  "auth.login.forgot_password": "Forgot your password?",
  "auth.login.log_in": "Log in",
  "auth.login.password.label": "Password",
  "auth.login.password.placeholder": "Password",
  "auth.login.password.required": "Password is required",
  "auth.login.email.error_format": "Please enter a valid email"
}
